
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/no_schools",
      function () {
        return require("private-next-pages/no_schools/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/no_schools"])
      });
    }
  